/**
 * 404 catch-all del portale paziente.
 *
 * Il portale espone SOLO 4 route specifiche; qualunque altra path
 * (o tentativo di scoperta) ritorna questa pagina, con messaggio
 * generico per non rivelare la struttura interna.
 */

import { OnboardingShell } from '../components/OnboardingShell';

export function OnboardingNotFoundPage() {
  return (
    <OnboardingShell>
      <div className="text-center py-8 md:py-16">
        <div
          className="w-16 h-16 mx-auto mb-6 rounded-full bg-surface-container flex items-center justify-center"
          aria-hidden="true"
        >
          <span className="material-symbols-outlined text-text-secondary text-3xl">
            help_outline
          </span>
        </div>
        <h1 className="text-2xl md:text-3xl font-semibold text-text-main mb-3">
          Pagina non trovata
        </h1>
        <p className="text-text-secondary text-base md:text-lg">
          La pagina che stai cercando non esiste.
        </p>
        <p className="text-text-secondary text-sm mt-3">
          Se hai ricevuto un link di onboarding, verifica di averlo copiato
          interamente.
        </p>
      </div>
    </OnboardingShell>
  );
}
